import { render, staticRenderFns } from "./BlackListForm.vue?vue&type=template&id=5b0894f4&"
import script from "./BlackListForm.vue?vue&type=script&lang=js&"
export * from "./BlackListForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports